import { render, staticRenderFns } from "./UploadView.vue?vue&type=template&id=49b0e566&scoped=true&"
import script from "./UploadView.vue?vue&type=script&lang=js&"
export * from "./UploadView.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./UploadView.vue?vue&type=style&index=0&id=49b0e566&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "49b0e566",
  null
  ,true
)

export default component.exports